export default "__VITE_ASSET__fe20bbf3__"